import { ApiAccessKeysScreen, PluginSetup as UIUserManagement } from '@leverege/api-ui-user-management';
import useResponsiveBreakPoints from "../../views/hooks/UseResponsiveBreakpoints.js";
import MobileApiAccessKeyManagementScreen from "./MobileApiAccessKeyManagementScreen.js";
const components = {
  small: MobileApiAccessKeyManagementScreen,
  big: ApiAccessKeysScreen
};
UIUserManagement.install(window.Molten);
export default function ResponsiveApiAccessKeyManagementScreen(props) {
  return useResponsiveBreakPoints(components, props);
}